import { createBrowserRouter, Navigate } from "react-router-dom";
// eslint-disable-next-line
import React from "react";
import { useSelector } from "react-redux";
import Home from "../pages/Home";
import App from "../App";
import NotFound from "../pages/404";
import SignIn from "../pages/SignIn";
import SignUp from "../pages/SignUp";
import UserProfile from "../pages/UserProfile";
import AdminPanel from "../pages/AdminPanel";
import AllUsers from "../pages/AllUsers";
import AllProducts from "../pages/AllProducts";
import CategoryProduct from "./../pages/categoryProduct";
import ProductDetails from "./../pages/productDetails";
import Cart from "../pages/Cart";
import SearchCart from "../pages/SearchCart";
import Success from "../pages/Success";
import Cancel from "../pages/Cancel";
import Order from "../pages/Order";
import AllOrders from "../pages/AllOrders";
import ViewAllProducts from "../pages/ViewAllProducts";
import ArrivalProducts from "../pages/ArrivalProducts";
import DiscountProducts from "../pages/DiscountProducts";
import WishlistCart from "../pages/WishlistCart";
import About from "../pages/About";

// ProtectedRoute component to handle authentication
const ProtectedRoute = ({ element }) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  return isAuthenticated ? element : <Navigate to="/sign-in" />;
};

const PublicRoute = ({ element }) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  // Redirect authenticated users to the homepage
  return isAuthenticated ? <Navigate to="/" /> : element;
};

// AdminRequired component to handle admin access
const AdminRequired = ({ element }) => {
  const isAdmin = useSelector((state) => state.admin.isAdmin);
  return isAdmin ? <ProtectedRoute element={element} /> : <Navigate to="/" />;
};

// Define routes in a separate array for better readability
const routes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "sign-in",
    element: <PublicRoute  element={<SignIn />} />
    // element: <SignIn />,
  },
  {
    path: "sign-up",
    element: <PublicRoute  element={<SignUp />} />
    // element: <SignUp />,
  },
  {
    path: "category-product/:category",
    element: <CategoryProduct />,
  },
  {
    path: "product/:id",
    element: <ProductDetails />,
  },
  {
    path: "cart",
    element: <Cart />,
  },
  {
    path: "user-profile",
    element: <ProtectedRoute element={<UserProfile />} />,
  },
  {
    path: "search-cart",
    element: <SearchCart />,
  },
  { path: "success", element: <Success /> },
  {
    path: "cancel",
    element: <Cancel />,
  },
  {
    path: "order",
    element: <Order />,
  },
  {
    path:"view-products",
    element: <ViewAllProducts />,
  },
  {
    path:"arrival-products",
    element: <ArrivalProducts />,
  },
  {
    path:"discount-products",
    element: <DiscountProducts />,
  },
  {
    path:"wishlist-products",
    element: <WishlistCart />,
  },
  {
    path:"about",
    element: <About />,
  },

  {
    path: "admin-panel",
    element: <AdminRequired element={<AdminPanel />} />,
    children: [
      {
        path: "all-users",
        element: <AdminRequired element={<AllUsers />} />,
      },
      {
        path: "all-products",
        element: <AdminRequired element={<AllProducts />} />,
      },
      {
        path: "all-orders",
        element: <AdminRequired element={<AllOrders />} />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

// Create the router with the defined routes
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <NotFound />,
    children: routes,
  },
]);

export default router;
